import type { AccountType } from '@pulsify/shared/auth-roles'

/**
 * Dashboard-side mapping from `AccountType` (the wire convention shared
 * with the backend) to the login route an invitee or recovery-flow user
 * should land on after setting their password.
 *
 * The dashboard exposes exactly two portals today - `/admin-login` for
 * global admins and `/login` for everyone else. `'sales'` and `'user'`
 * fall through to the generic `/login`; when a dedicated `/sales-login`
 * (or any other portal) ships, only this switch needs an extra case.
 */
export function loginRouteForAccountType(role: AccountType): '/login' | '/admin-login' {
  switch (role) {
    case 'admin':
      return '/admin-login'
    case 'business':
    case 'sales':
    case 'user':
      return '/login'
  }
}
